import { useQuery } from 'react-query';
import { fetcher } from '../../client'
import { fetchPackages, fetchSkuById, fetchPlanById } from '../../actions/stripe'

export function usePackages(params = {}, options) {
  return useQuery(['stripe-packages', params], () => fetcher(fetchPackages(params)), options)
}

export function useFetchSkuById(skuId, options) {
  return useQuery(['stripe-sku', skuId], () => fetcher(fetchSkuById(skuId)), options)
}

export function useFetchPlanById(planId, options) {
  return useQuery(['stripe-plan', planId], () => fetcher(fetchPlanById(planId)), options)
}